module.exports = __webpack_public_path__ + "img/breathing-good.ecaebe26.svg";